import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export const initialState = {
    telcos: [],
    data_categories: [],
    data_services: {}
}

export default {
    namespaced: true,
    state: { ...initialState },
    getters,
    actions,
    mutations,
}
